import React from "react";
import { TabGroup, TabList, Tab } from "@headlessui/react";
import SearchInput from "./searchInput";
import { experiencesFilterItems, activitiesFilterItems } from "./filterItems";
import useExperiencesStore from "@/stores/tripBuilder/useExperiences";
import { toast } from "@/hooks/use-toast";

interface ExperienceSearchProps {
  selectedExperienceTabIndex: number;
  setSelectedExperienceTabIndex: (index: number) => void;
  handleTabChange: (index: number) => void;
  selectedFilter: string | null;
  setSelectedFilter: (filter: string | null) => void;
  setSelectedExperience: (details: any) => void;
  isAdmin: boolean;
}

const ExperienceSearch: React.FC<ExperienceSearchProps> = ({
  selectedExperienceTabIndex,
  setSelectedExperienceTabIndex,
  handleTabChange,
  selectedFilter,
  setSelectedFilter,
  setSelectedExperience,
  isAdmin,
}) => {
  let filterItems = activitiesFilterItems;
  const { activeExperiencesTab, setActiveExperiencesTab } =
    useExperiencesStore();

  if (selectedExperienceTabIndex === 1) {
    filterItems = experiencesFilterItems;
  }

  return (
    <section className="w-full">
      <div className="w-full">
        <TabGroup
          selectedIndex={selectedExperienceTabIndex}
          onChange={(index) => {
            if (!isAdmin && index === 2) {
              toast({
                title: "Viewer access restricted",
                description:
                  "Create a copy of this trip to add custom activities",
                duration: 3000,
              });
            } else {
              setSelectedExperienceTabIndex(index);
              if (index === 0) setActiveExperiencesTab("experiences");
              else if (index === 1) setActiveExperiencesTab("activities");
              else setActiveExperiencesTab("add-activity");
              handleTabChange(index);
            }
          }}
          className="w-full"
        >
          <TabList className="flex flex-row w-full space-x-2">
            <Tab className="rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700 focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out">
              <i className="fa-solid fa-mountain-city"></i>
              <span>Experiences</span>
            </Tab>
            <Tab className="rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700 focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out">
              <i className="fas fa-binoculars"></i>
              <span>Things to Do</span>
            </Tab>

            <Tab
              className={`rounded-full flex flex-row items-center justify-center space-x-3 w-full py-1 px-3 text-sm/6 font-normal data-[selected]:font-medium ${
                !isAdmin
                  ? "opacity-20"
                  : "text-neutral-500 data-[selected]:text-neutral-800 hover:text-neutral-700"
              } focus:outline-none data-[selected]:bg-neutral-500/15 data-[hover]:bg-neutral-200/50 data-[selected]:data-[hover]:bg-neutral-500/30 data-[focus]:outline-0 duration-500 transition-all ease-in-out`}
            >
              <i className="fa-solid fa-pen-field"></i>
              <span>Add Custom</span>
            </Tab>
          </TabList>
        </TabGroup>
      </div>
      <div className="mt-2">
        <SearchInput
          activeExperiencesTab={activeExperiencesTab}
          filterItems={filterItems}
          selectedFilter={selectedFilter}
          setSelectedFilter={setSelectedFilter}
          setSelectedExperience={setSelectedExperience}
        />
      </div>
    </section>
  );
};

export default ExperienceSearch;
